import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 1350,
  height: 760,
  x: 50,
  y: 50,
  list: [
    {
      id: '117096c8-704e-4036-ac55-b7542d9f05da',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '84f973b4-4c20-4d52-8514-5ca4a559dca3',
      type: 'NineSlicePlane',
      name: 'bg',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 640,
        y: 368
      },
      width: 1280,
      height: 736,
      leftWidth: 244,
      topHeight: 128,
      rightWidth: 207,
      bottomHeight: 141,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'base',
      parent: '117096c8-704e-4036-ac55-b7542d9f05da',
      data: ''
    },
    {
      id: '0dc17e9e-ca9d-461c-b8a6-6ee460154863',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'popup_title_bg',
      parent: '117096c8-704e-4036-ac55-b7542d9f05da',
      data: ''
    },
    {
      id: '721df5ee-3cf9-44fa-b250-5b2b2ba31546',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 563,
      y: -278,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_close',
      parent: '117096c8-704e-4036-ac55-b7542d9f05da',
      data: ''
    },
    {
      id: '38bb642d-5b87-4cd6-a0c7-03336d364f9d',
      type: 'Container',
      name: 'popup',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '117096c8-704e-4036-ac55-b7542d9f05da',
      data: ''
    },
    {
      id: '05e834aa-a3ce-45c1-b6b1-fe0231e30312',
      type: 'Container',
      name: 'noProductsContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '117096c8-704e-4036-ac55-b7542d9f05da',
      data: ''
    },
    {
      id: '50ac4349-77cc-4434-a1dd-8135fb6cffe0',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Shop',
      localize: true,
      maxWidth: 458,
      maxHeight: 112,
      maxFontSize: 50,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#9A3234',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '0dc17e9e-ca9d-461c-b8a6-6ee460154863',
      data: ''
    },
    {
      id: 'ad38d4c6-2fbc-40f0-b9cb-76b9f8aa78fb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -474,
      y: -100,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_small_base',
      parent: '38bb642d-5b87-4cd6-a0c7-03336d364f9d',
      data: ''
    },
    {
      id: '810dcf00-d2f1-4a28-a608-b00cba7d38f3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -266,
      y: -100,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_small_base',
      parent: '38bb642d-5b87-4cd6-a0c7-03336d364f9d',
      data: ''
    },
    {
      id: '9c82a20d-0b09-4c72-a804-160ce7c93679',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -474,
      y: 152,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_small_base',
      parent: '38bb642d-5b87-4cd6-a0c7-03336d364f9d',
      data: ''
    },
    {
      id: 'b5383ac6-3aa3-4c49-8181-20e8c84cb298',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -266,
      y: 152,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_small_base',
      parent: '38bb642d-5b87-4cd6-a0c7-03336d364f9d',
      data: ''
    },
    {
      id: '640f9751-eeac-425c-abb2-bb1d32010498',
      type: 'Sprite',
      name: 'jokerPack',
      nameSpace: '',
      className: '',
      x: 25,
      y: 28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_joker_deal',
      parent: '38bb642d-5b87-4cd6-a0c7-03336d364f9d',
      data: ''
    },
    {
      id: '8eaace32-3550-4133-97b4-664cffba54dc',
      type: 'Container',
      name: 'specialOffer',
      nameSpace: '',
      className: '',
      x: 403,
      y: 28,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: false,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '38bb642d-5b87-4cd6-a0c7-03336d364f9d',
      data: ''
    },
    {
      id: 'bc181ced-a7e8-4925-8ed5-ff1957a7a417',
      type: 'Container',
      name: 'starterPack',
      nameSpace: '',
      className: '',
      x: 213,
      y: 34,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '38bb642d-5b87-4cd6-a0c7-03336d364f9d',
      data: ''
    },
    {
      id: 'a380901a-e348-4342-bfff-61f6021ce730',
      type: 'Sprite',
      name: 'noAds',
      nameSpace: '',
      className: '',
      x: 2,
      y: 320,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_ads_tape',
      parent: '38bb642d-5b87-4cd6-a0c7-03336d364f9d',
      data: ''
    },
    {
      id: '140f7376-e798-4970-b3ea-19393713811f',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -30,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'CheckInternet',
      localize: true,
      maxWidth: 1104,
      maxHeight: 67,
      maxFontSize: 32,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8b3130',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '05e834aa-a3ce-45c1-b6b1-fe0231e30312',
      data: ''
    },
    {
      id: 'c324f7fa-8646-422b-9515-2a41cedf1a82',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 60,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'ConnectionErrorInfo',
      localize: true,
      maxWidth: 1104,
      maxHeight: 124,
      maxFontSize: 32,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#8b3130',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '05e834aa-a3ce-45c1-b6b1-fe0231e30312',
      data: ''
    },
    {
      id: '5b3e0ed1-e779-4df8-86f3-e7bba112daa3',
      type: 'Sprite',
      name: 'freeLevelIcon',
      nameSpace: '',
      className: '',
      x: 4,
      y: -50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'icon_free_level',
      parent: 'ad38d4c6-2fbc-40f0-b9cb-76b9f8aa78fb',
      data: ''
    },
    {
      id: '0fb43ebc-1082-44de-b0e2-07c486d1f7f8',
      type: 'Sprite',
      name: 'coinIconPackA',
      nameSpace: '',
      className: '',
      x: 0,
      y: -50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_coin_10',
      parent: 'ad38d4c6-2fbc-40f0-b9cb-76b9f8aa78fb',
      data: ''
    },
    {
      id: 'ee90dc9d-37fe-49d8-b08a-53a1d3a3c51d',
      type: 'Text',
      name: 'amountPackA',
      nameSpace: '',
      className: '',
      x: 3,
      y: 4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '10,000',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#ffffff',
        stroke: '#1B619B',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ad38d4c6-2fbc-40f0-b9cb-76b9f8aa78fb',
      data: ''
    },
    {
      id: 'e486ad3c-73ec-4c2a-9e8c-e0ae5a60ee7a',
      type: 'Sprite',
      name: 'buyButtonPackA',
      nameSpace: '',
      className: '',
      x: 0,
      y: 80,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'no_padding_button',
      parent: 'ad38d4c6-2fbc-40f0-b9cb-76b9f8aa78fb',
      data: ''
    },
    {
      id: '321e139a-d84d-4891-95a2-af539a1afd2f',
      type: 'Sprite',
      name: 'coinIconPackB',
      nameSpace: '',
      className: '',
      x: 4,
      y: -54,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_coin_60',
      parent: '810dcf00-d2f1-4a28-a608-b00cba7d38f3',
      data: ''
    },
    {
      id: '57ef6b64-7bb5-4bf3-9614-704274d446a4',
      type: 'Text',
      name: 'amountPackB',
      nameSpace: '',
      className: '',
      x: 3,
      y: 4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '60,000',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#ffffff',
        stroke: '#1B619B',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '810dcf00-d2f1-4a28-a608-b00cba7d38f3',
      data: ''
    },
    {
      id: '9b73cfbb-f402-4c69-9e3b-718e55bf193d',
      type: 'Sprite',
      name: 'buyButtonPackB',
      nameSpace: '',
      className: '',
      x: 0,
      y: 80,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'no_padding_button',
      parent: '810dcf00-d2f1-4a28-a608-b00cba7d38f3',
      data: ''
    },
    {
      id: '75774012-a285-4070-95ce-bd5ea6a319fe',
      type: 'Sprite',
      name: 'coinIconPackC',
      nameSpace: '',
      className: '',
      x: -2,
      y: -45,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_coin_400',
      parent: '9c82a20d-0b09-4c72-a804-160ce7c93679',
      data: ''
    },
    {
      id: '2ec72219-0462-470e-88f1-55b47a93bd14',
      type: 'Text',
      name: 'amountPackC',
      nameSpace: '',
      className: '',
      x: 3,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '125,000',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#ffffff',
        stroke: '#1B619B',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '9c82a20d-0b09-4c72-a804-160ce7c93679',
      data: ''
    },
    {
      id: 'ccf72518-1626-435e-8a42-d64886b30bb2',
      type: 'Sprite',
      name: 'buyButtonPackC',
      nameSpace: '',
      className: '',
      x: 0,
      y: 80,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'no_padding_button',
      parent: '9c82a20d-0b09-4c72-a804-160ce7c93679',
      data: ''
    },
    {
      id: 'c1671bc4-cb29-4da6-921a-a0f12eeb95a8',
      type: 'Sprite',
      name: 'coinIconPackD',
      nameSpace: '',
      className: '',
      x: -2,
      y: -45,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_coin_1m',
      parent: 'b5383ac6-3aa3-4c49-8181-20e8c84cb298',
      data: ''
    },
    {
      id: 'd7c3e4b5-e17a-429b-9994-c5de18e99860',
      type: 'Text',
      name: 'amountPackD',
      nameSpace: '',
      className: '',
      x: 3,
      y: 7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1,250,000',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#ffffff',
        stroke: '#1B619B',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'b5383ac6-3aa3-4c49-8181-20e8c84cb298',
      data: ''
    },
    {
      id: 'c4bd1e30-0bbc-47db-9129-6c55736338c3',
      type: 'Sprite',
      name: 'buyButtonPackD',
      nameSpace: '',
      className: '',
      x: 0,
      y: 80,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'no_padding_button',
      parent: 'b5383ac6-3aa3-4c49-8181-20e8c84cb298',
      data: ''
    },
    {
      id: 'efe0bd81-b17a-4e53-83bb-4c788dfcded3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -67,
      y: -92,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_best_deal_badge',
      parent: 'b5383ac6-3aa3-4c49-8181-20e8c84cb298',
      data: ''
    },
    {
      id: '9f1c2bb2-0d15-4975-888b-2a8daa14d7a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -89,
      y: -125,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'icon_free_level',
      parent: '640f9751-eeac-425c-abb2-bb1d32010498',
      data: ''
    },
    {
      id: '03b558ad-c73a-4d25-aa47-fced8a4fc1dc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 73,
      y: -125,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_joker_cards',
      parent: '640f9751-eeac-425c-abb2-bb1d32010498',
      data: ''
    },
    {
      id: '2817adc4-ca1d-48f4-b555-9401d510227b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -4,
      y: 26,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_coin_100',
      parent: '640f9751-eeac-425c-abb2-bb1d32010498',
      data: ''
    },
    {
      id: 'e5398dcf-86c6-44db-ac53-bd6b3b6fcdc5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -131,
      y: -216,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_joker_badge',
      parent: '640f9751-eeac-425c-abb2-bb1d32010498',
      data: ''
    },
    {
      id: 'bf3ed97d-0d37-4533-9155-427edac2e721',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: -86,
      y: -73,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x25',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#ffffff',
        stroke: '#18527F',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '640f9751-eeac-425c-abb2-bb1d32010498',
      data: ''
    },
    {
      id: 'c06f29d3-8910-4e95-a84b-87b859551b1f',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 72,
      y: -73,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x50',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#ffffff',
        stroke: '#18527F',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '640f9751-eeac-425c-abb2-bb1d32010498',
      data: ''
    },
    {
      id: 'caff5b48-6f91-467e-85f1-c1d362ac5a64',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 112,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '100,000',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 41,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#ffffff',
        stroke: '#18527F',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '640f9751-eeac-425c-abb2-bb1d32010498',
      data: ''
    },
    {
      id: '59c78f97-956e-41a9-86d6-9f1d6271aa0d',
      type: 'Sprite',
      name: 'buyButtonJokerPack',
      nameSpace: '',
      className: '',
      x: 0,
      y: 198,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_long',
      parent: '640f9751-eeac-425c-abb2-bb1d32010498',
      data: ''
    },
    {
      id: 'ceae751c-eda4-4eda-be07-aa4b6649e17b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -202,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_small_tape_2',
      parent: '8eaace32-3550-4133-97b4-664cffba54dc',
      data: ''
    },
    {
      id: 'd1ad8a46-574b-40cb-bfbf-ecf03b59bb2a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_special_offer',
      parent: '8eaace32-3550-4133-97b4-664cffba54dc',
      data: ''
    },
    {
      id: 'be7f7009-51fe-4159-9a7b-b176bf9605e6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -82,
      y: -125,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'icon_free_level',
      parent: '8eaace32-3550-4133-97b4-664cffba54dc',
      data: ''
    },
    {
      id: '7084c514-25fe-48cd-9562-de5b93d628e8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 93,
      y: -128,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_+5_cards',
      parent: '8eaace32-3550-4133-97b4-664cffba54dc',
      data: ''
    },
    {
      id: '73e1c9e6-3f99-45fa-aaac-cdbe30f89447',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1,
      y: 28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_coin_65',
      parent: '8eaace32-3550-4133-97b4-664cffba54dc',
      data: ''
    },
    {
      id: 'a0f7efbf-6578-4ae7-9730-4bc8788eda97',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -223,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.01,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_small_tape',
      parent: '8eaace32-3550-4133-97b4-664cffba54dc',
      data: ''
    },
    {
      id: 'bf7587db-ee6f-4365-8d72-722d4ff00097',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: -73,
      y: -72,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x20',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#ffffff',
        stroke: '#0F6D4B',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8eaace32-3550-4133-97b4-664cffba54dc',
      data: ''
    },
    {
      id: 'a7859a26-6f86-4f9e-829b-8191ec1d1bb2',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 89,
      y: -73,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x20',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#ffffff',
        stroke: '#0F6D4B',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8eaace32-3550-4133-97b4-664cffba54dc',
      data: ''
    },
    {
      id: '3b11a0e2-7b21-4376-8eda-0704b487720f',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 3,
      y: 112,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '65,000',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 41,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#ffffff',
        stroke: '#0F6D4B',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8eaace32-3550-4133-97b4-664cffba54dc',
      data: ''
    },
    {
      id: '1a7adca2-e1ae-4986-b223-d668e9f80045',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 3,
      y: -236,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'SpecialOffer',
      localize: true,
      maxWidth: 315,
      maxHeight: 88,
      maxFontSize: 37,
      icons: [],
      style: {
        fontSize: 41,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#C61D15',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8eaace32-3550-4133-97b4-664cffba54dc',
      data: ''
    },
    {
      id: 'c25691de-5d64-42fb-8d75-cd7c0e8144a9',
      type: 'Sprite',
      name: 'buyButtonSpecialPack',
      nameSpace: '',
      className: '',
      x: 0,
      y: 198,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_long',
      parent: '8eaace32-3550-4133-97b4-664cffba54dc',
      data: ''
    },
    {
      id: '74c3faa8-111e-4893-93cd-a88172badad3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.97048,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_base_big',
      parent: 'bc181ced-a7e8-4925-8ed5-ff1957a7a417',
      data: ''
    },
    {
      id: '895bd9f7-d4c4-4d5d-adbc-d055b74cdc43',
      type: 'Container',
      name: 'starterPackAnimationContainer',
      nameSpace: '',
      className: '',
      x: -1,
      y: -4,
      scale: {
        x: 0.952,
        y: 0.96
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'bc181ced-a7e8-4925-8ed5-ff1957a7a417',
      data: ''
    },
    {
      id: '7150a42a-44c4-43af-8247-662585ef59e0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 153,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.012179,
        y: 0.9
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_starterpack_pic',
      parent: 'bc181ced-a7e8-4925-8ed5-ff1957a7a417',
      data: ''
    },
    {
      id: '85cc3c12-a36a-4e8a-b8da-d6e9d2cd728c',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: -179,
      y: 80,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '30,000',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'ArchivoBlack',
        fill: '#ffffff',
        stroke: '#9B0025',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'bc181ced-a7e8-4925-8ed5-ff1957a7a417',
      data: ''
    },
    {
      id: '77af4312-a6a1-4455-bc33-7a6d8493c0fe',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 14,
      y: 78,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x5',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#9B0025',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'bc181ced-a7e8-4925-8ed5-ff1957a7a417',
      data: ''
    },
    {
      id: '5aa4ceb8-5485-407c-8c28-0e506cf7c31b',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 148,
      y: 78,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x5',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#9B0025',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'bc181ced-a7e8-4925-8ed5-ff1957a7a417',
      data: ''
    },
    {
      id: '640e7e47-51cd-43c9-8e6b-38b759c76857',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 276,
      y: 77,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x5',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#9B0025',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'bc181ced-a7e8-4925-8ed5-ff1957a7a417',
      data: ''
    },
    {
      id: '106dd694-0d40-4e15-94c9-2efa694258fb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -208,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.009,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_starterpack_tape',
      parent: 'bc181ced-a7e8-4925-8ed5-ff1957a7a417',
      data: ''
    },
    {
      id: '77df7089-76f3-4924-be63-2982a97f3949',
      type: 'Sprite',
      name: 'buyButtonStarterPack',
      nameSpace: '',
      className: '',
      x: 0,
      y: 198,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.24,
        y: 1.24
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_long',
      parent: 'bc181ced-a7e8-4925-8ed5-ff1957a7a417',
      data: ''
    },
    {
      id: '08ad3ed5-b1ad-4195-a6ab-2dda25a8ffe9',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'MakeAnyPurchaseRemoveAds',
      localize: true,
      maxWidth: 1027,
      maxHeight: 40,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: '#833826',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'a380901a-e348-4342-bfff-61f6021ce730',
      data: ''
    },
    {
      id: '2b771154-8c8b-40ef-b459-fe9e48942289',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -553,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'shop_ads_icon',
      parent: 'a380901a-e348-4342-bfff-61f6021ce730',
      data: ''
    },
    {
      id: '24e61732-5408-4c64-a7f3-42e2640ba7c6',
      type: 'Text',
      name: 'pricePackA',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 1,99',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#297A12',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'e486ad3c-73ec-4c2a-9e8c-e0ae5a60ee7a',
      data: ''
    },
    {
      id: 'ec6e3a68-966c-4798-a585-dab0e1a87bcb',
      type: 'Text',
      name: 'pricePackB',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 2,99',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#297A12',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '9b73cfbb-f402-4c69-9e3b-718e55bf193d',
      data: ''
    },
    {
      id: '601f6e2d-0569-4ea3-84db-f426fc034b14',
      type: 'Text',
      name: 'pricePackC',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 4,99',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#297A12',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'ccf72518-1626-435e-8a42-d64886b30bb2',
      data: ''
    },
    {
      id: '868334ae-760b-4121-98e7-4d33b5f37311',
      type: 'Text',
      name: 'pricePackD',
      nameSpace: '',
      className: '',
      x: 0,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 49,99',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#297A12',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'c4bd1e30-0bbc-47db-9129-6c55736338c3',
      data: ''
    },
    {
      id: 'b7027e89-9d64-4499-83c9-8d52e11f5d3b',
      type: 'Text',
      name: 'priceJokerPack',
      nameSpace: '',
      className: '',
      x: 0,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 19,99',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#297A12',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '59c78f97-956e-41a9-86d6-9f1d6271aa0d',
      data: ''
    },
    {
      id: 'e517e3dd-994f-46f1-ba40-793c0da99aaa',
      type: 'Text',
      name: 'priceSpecialPack',
      nameSpace: '',
      className: '',
      x: 0,
      y: -9,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 9,99',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#297A12',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'c25691de-5d64-42fb-8d75-cd7c0e8144a9',
      data: ''
    },
    {
      id: '6d9952c3-8a14-499c-bca4-c0fd95b3593f',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -21,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'StarterPack',
      localize: true,
      maxWidth: 605,
      maxHeight: 52,
      maxFontSize: 32,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#9B0025',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '106dd694-0d40-4e15-94c9-2efa694258fb',
      data: ''
    },
    {
      id: 'ad41705c-464e-4b66-b5ff-72cefcdb55e2',
      type: 'Text',
      name: 'priceStarterPack',
      nameSpace: '',
      className: '',
      x: 0,
      y: 1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 0,99',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 40,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffe400',
        stroke: '#297A12',
        strokeThickness: 6,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '77df7089-76f3-4924-be63-2982a97f3949',
      data: ''
    },
    {
      id: '83d6d290-d1dc-42a4-922c-5798bc238dcb',
      type: 'Text',
      name: 'starterPackOldPrice',
      nameSpace: '',
      className: '',
      x: 0,
      y: -28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$ 2.99',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 22,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#fafafa',
        stroke: '#297A12',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '77df7089-76f3-4924-be63-2982a97f3949',
      data: ''
    },
    {
      id: 'e82752e3-7d75-42cc-ab64-9868ee55f956',
      type: 'Text',
      name: 'starterPackStrike',
      nameSpace: '',
      className: '',
      x: 0,
      y: -26,
      anchor: {
        x: 0.5,
        y: 0.65
      },
      scale: {
        x: 4,
        y: 0.6
      },
      angle: -10,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '━',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#CF0E0E',
        stroke: '#17762E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 0.5,
        dropShadowAngle: 1.4,
        dropShadowBlur: 2,
        dropShadowColor: 'black',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '77df7089-76f3-4924-be63-2982a97f3949',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class ShopLayout {
  static raw = raw;
  root: PIXI.Container
  bg: PIXI.NineSlicePlane
  closeButton: PIXI.Sprite
  popup: PIXI.Container
  freeLevelIcon: PIXI.Sprite
  coinIconPackA: PIXI.Sprite
  amountPackA: PIXI.Text
  buyButtonPackA: PIXI.Sprite
  pricePackA: PIXI.Text
  coinIconPackB: PIXI.Sprite
  amountPackB: PIXI.Text
  buyButtonPackB: PIXI.Sprite
  pricePackB: PIXI.Text
  coinIconPackC: PIXI.Sprite
  amountPackC: PIXI.Text
  buyButtonPackC: PIXI.Sprite
  pricePackC: PIXI.Text
  coinIconPackD: PIXI.Sprite
  amountPackD: PIXI.Text
  buyButtonPackD: PIXI.Sprite
  pricePackD: PIXI.Text
  jokerPack: PIXI.Sprite
  buyButtonJokerPack: PIXI.Sprite
  priceJokerPack: PIXI.Text
  specialOffer: PIXI.Container
  buyButtonSpecialPack: PIXI.Sprite
  priceSpecialPack: PIXI.Text
  starterPack: PIXI.Container
  starterPackAnimationContainer: PIXI.Container
  buyButtonStarterPack: PIXI.Sprite
  priceStarterPack: PIXI.Text
  starterPackOldPrice: PIXI.Text
  starterPackStrike: PIXI.Text
  noAds: PIXI.Sprite
  noProductsContainer: PIXI.Container

  constructor() {
    populate(this, raw);
  }
}
